import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className", "hasError", "hasSuccess", "required", "min", "max", "value", "onChange", "onValidChange", "onDeleteChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import { useRef, useEffect } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { TimeField } from '@mui/x-date-pickers/TimeField';
import { stripUnicodeChars } from '@/utils/strings';
import { triggerNativeEvent } from '@/utils/dom';
import { isValidDuration, durationStringToNumber, durationNumberToMoment } from '@/utils/time';
import { customFormValidityMethod } from '@/config/general';
import formatConfig from '@/config/formats';
import { isValidForMax, isValidForMin } from '@/utils/validation';
import formStyles from '../styles.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const FORMAT = formatConfig.defaultDuration;

const Duration = _ref => {
  let {
    className,
    hasError,
    hasSuccess,
    required,
    min,
    max,
    value,
    onChange = () => null,
    onValidChange = () => null,
    onDeleteChange = () => null
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  const inputRef = useRef(null); // Determine if user aswer is valid
  // if require and any min/max requirements

  const validate = () => {
    var _inputRef$current;

    let isValid = true;
    if (!inputRef || !(inputRef !== null && inputRef !== void 0 && inputRef.current)) return isValid;
    const srcVal = stripUnicodeChars((inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.value) || '');
    const duration = durationStringToNumber(toParsable(srcVal || '00:00:00')); // Check required

    if (required) {
      isValid = hasCompleteAnswer(srcVal);
    } // Check min/max


    if (isValid) {
      isValid = isValidForMin(duration, min);
      isValid = isValid ? isValidForMax(duration, max) : false;
    }

    return isValid;
  }; // Add custom validition method


  useEffect(() => {
    if (inputRef.current) {
      inputRef.current[customFormValidityMethod] = validate;
    } // Cleanup custom method


    return () => {
      if (inputRef.current) delete inputRef.current[customFormValidityMethod];
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputRef.current, validate]);
  return /*#__PURE__*/_jsx(LocalizationProvider, {
    dateAdapter: AdapterMoment,
    children: /*#__PURE__*/_jsx(TimeField, _objectSpread({
      className: clsx(formStyles.input, formStyles.muiField, styles.container, hasError && formStyles['muiField--hasError'], hasSuccess && formStyles['muiField--hasSuccess'], className || ''),
      inputRef: element => {
        inputRef.current = element;
      },
      value: durationNumberToMoment(typeof value === 'number' && !isNaN(value) ? value : 0),
      format: FORMAT,
      onChange: evt => {
        // @ts-ignore
        const updateValue = evt && evt.format(FORMAT) || '';

        if (!isValidDuration(updateValue)) {
          onDeleteChange();
          return;
        }

        const duration = durationStringToNumber(toParsable(updateValue || '00:00:00')); // Send all publishable changes

        onChange(duration);

        if (inputRef.current) {
          triggerNativeEvent(inputRef.current, {
            event: 'input',
            value: duration
          });
        } // Send only valid changes


        if (isValidForMin(duration, min) && isValidForMax(duration, max)) {
          onValidChange(duration);
        }
      }
    }, props))
  });
};

export default Duration; // Answer has hour, minute, second answered

function hasCompleteAnswer(val) {
  return val.search(/h|m|s/i) === -1;
} // Convert placeholder values to zeros


function toParsable(str) {
  return str.split(/:|\./) // Create segements
  .map(function () {
    let seg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '00';
    return seg.replace(/h|m|s/gi, '0');
  }) // Placeholders to 0's
  .map(seg => seg.replace(/\D/g, '')) // Remove non-numberic chars
  .join(':'); // Normalize separators
}